"use client";
import * as React from "react";
import { store } from "@AdbhutByte/utils/config/ui/state/store";
import { Provider } from "react-redux";

export function Providers({ children }: { children: React.ReactNode }) {
  return <Provider store={store}>{children}</Provider>;
}
